import { Button, CityState, DataSource, Label, Layout, Panel, Tab, Table, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutCarrierCapacity extends Layout {
    buttonAddTractor: Button;
    citystateLoadTo: CityState;
    citystateLocation: CityState;
    labelAddTractor: Label;
    labelAvailableLoads: Label;
    labelCarrier: Label;
    labelWarningImage: Label;
    panelAddTractor: Panel;
    panelAddTractors: Panel;
    panelAvailableLoads: Panel;
    panelCarrier: Panel;
    panelTractors: Panel;
    panelWarning: Panel;
    sourceAvailTractDetail: DataSource;
    sourceCarrier: DataSource;
    tabAddTractors: Tab;
    tableAddedTractors: Table;
    tabsetAddTractor: Tabset;
    tabsetAvailableLoads: Tabset;
    textboxAvailable: Textbox;
    textboxCallBackNumber: Textbox;
    textboxCarrierContactName: Textbox;
    textboxCarrierName: Textbox;
    textboxComments: Textbox;
    textboxEmailAddress: Textbox;
    textboxTrailerType: Textbox;
}
